import { InstallCustomerRequest } from 'src/modules/support/models/installCustomerRequest';
import AxiosInstance from './axios/interceptor';

const controller = 'System';

export const createCustomer = (data: InstallCustomerRequest) => {
  const endpoint = `${controller}/InstallCustomer`;
  return AxiosInstance.put(endpoint, data);
};
